import config from 'SRC/config/config.json'

export const adsSortTypes = config.filters.adsSortTypes
